export default function HomeDashboard() {
	return <h1>AAA</h1>;
}
